<template >
  <div
    class="form-group formways-component formways-textfield"
    :class="ctx.customClass"
    v-if="!ctx.hidden"
  >
    <label :for="ctx.key">
      {{ ctx.label }}
      <span v-if="ctx.validate.required" class="text-danger">*</span>
      <i
        v-if="ctx.tooltip"
        class="fa fa-question-circle"
        aria-hidden="true"
        data-toggle="tooltip"
        data-placement="right"
        :title="ctx.tooltip"
      ></i>
    </label>
    <input
      type="text"
      class="form-control"
      :id="ctx.key"
      :placeholder="ctx.placeholder"
      :required="ctx.validate.required"
      :disabled="ctx.disabled"
      v-model="value"
    />
    <small :id="ctx.key + 'Help'" class="form-text text-muted">
      {{ ctx.description }}
    </small>
  </div>
</template>

<script>
import FieldMixin from '../../mixins/FieldMixin';
import defaultSchema from './defaultSchema';

export default {
  name: 'textfield',
  mixins: [FieldMixin],
  beforeCreate() {
    // Default schema
    this.defaultSchema = defaultSchema;
  },
  created() {
    this.initFieldValue();
  },
  methods: {
    reset() {
      this.value = '';
      this.initFieldValue();
    }
  }
};
</script>
